import PositionAssignmentTabView from '@src/main/modules/reports/ui/components/PositionAssignmentTabView';
import ContentCard from '@src/main/shared/ui/components/card/ContentCard';
import TabHeader from '@src/main/shared/ui/components/header/TabHeader';
import { TabMenuTabChangeEvent } from 'primereact/tabmenu';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const PositionAssignmentView = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const { t } = useTranslation();

  const items = [{ label: t('reports.menu.positionassignment'), icon: 'pi pi-inbox' }];

  const handleTabChange = (event: TabMenuTabChangeEvent) => {
    setActiveIndex(event.index);
  };

  return (
    <ContentCard>
      <TabHeader
        title={t('reports.menu.positionassignment')}
        items={items}
        activeIndex={activeIndex}
        onTabChange={handleTabChange}
      />
      <PositionAssignmentTabView />
    </ContentCard>
  );
};

export default PositionAssignmentView;
